import {useMemo} from 'react'
import {useSelector} from 'react-redux'
import {getSeoActiveAttributes} from 'modules/meta/selectors'
import {useGetBreadcrumbQuery} from 'modules/seoApi'
import {getBreadcrumbParams} from 'modules/seoApi/selectors'
import {useRouter} from 'next/router'
import {getSeoBreadcrumb} from 'utils/server/searchSeo/getSeoBreadcrumb'

import {useIsSeoSRP} from './useIsSeoSRP'

/**
 * Retrieves the correct SEO breadcrumb for the Seo SRP from the preloaded
 * seo-api breadcrumb. Returns an empty array when not on a SEO SRP or when the
 * breadcrumb endpoint is unavailable.
 */
export const useSeoBreadcrumb = () => {
  const {query: pathParams} = useRouter()
  const seoAttributes = useSelector(getSeoActiveAttributes)
  const isSeoSRP = useIsSeoSRP()

  const params = useSelector(state =>
    getBreadcrumbParams(state, pathParams?.placeId)
  )
  const {breadcrumb} = useGetBreadcrumbQuery(params, {
    selectFromResult: result => ({breadcrumb: result?.data?.breadcrumb}),
    skip: !isSeoSRP
  })

  return useMemo(() => {
    if (!isSeoSRP) {
      return []
    }

    return getSeoBreadcrumb({breadcrumb, pathParams, seoAttributes})
  }, [isSeoSRP, breadcrumb, pathParams, seoAttributes])
}
